<template>
  <div class="ui-tab-badge" :class="classList">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    classList () {
      return `type-${this.type}`
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-tab-badge {
  @include flex-center;
  @include font-12;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: $border-radius-01;

  &.type-default {
    color: $gray-3;
    background-color: $gray-6;
  }

  &.type-success {
    color: $green-1;
    background-color: $green-4;
  }

  &.type-danger {
    color: $light-01;
    background-color: $red-1;
  }

  &.type-warning {
    color: $orange-1;
    background-color: $orange-4;
  }

  &.type-primary {
    color: $primary;
    background-color: $blue-4;
  }

  &.type-light-danger {
    color: $red-1;
    background-color: $red-4;
  }
}
</style>
